function chileNow() {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Santiago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(new Date());
  const map = {};
  parts.forEach((p) => {
    map[p.type] = p.value;
  });
  return new Date(`${map.year}-${map.month}-${map.day}T${map.hour}:${map.minute}:${map.second}`);
}

class DeliveryCountdown {
  constructor(el) {
    this.el = el;
    this.hoursEl = el.querySelector('[data-cd-hours]');
    this.minutesEl = el.querySelector('[data-cd-minutes]');
    this.secondsEl = el.querySelector('[data-cd-seconds]');
    this.dayLabelEl = el.querySelector('[data-cd-day-label]');
    this.cutoffHour = parseInt(el.dataset.cutoffHour, 10);
    if (Number.isNaN(this.cutoffHour)) this.cutoffHour = 12;
    this.cutoffMinute = parseInt(el.dataset.cutoffMinute, 10);
    if (Number.isNaN(this.cutoffMinute)) this.cutoffMinute = 0;

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  weekdayLabel(day) {
    const names = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    return `el ${names[day]}`;
  }

  computeTarget(now) {
    const day = now.getDay();
    const cutoffToday = new Date(now);
    cutoffToday.setHours(this.cutoffHour, this.cutoffMinute, 0, 0);
    const isWeekday = day >= 1 && day <= 5;

    if (isWeekday && now < cutoffToday) {
      return { target: cutoffToday, dayLabel: 'hoy mismo' };
    }

    let addDays = 1;
    let candidate = new Date(now);
    candidate.setDate(candidate.getDate() + addDays);
    while (candidate.getDay() === 0 || candidate.getDay() === 6) {
      addDays += 1;
      candidate = new Date(now);
      candidate.setDate(candidate.getDate() + addDays);
    }
    candidate.setHours(this.cutoffHour, this.cutoffMinute, 0, 0);

    const dayLabel = addDays === 1 ? 'mañana' : this.weekdayLabel(candidate.getDay());
    return { target: candidate, dayLabel };
  }

  tick() {
    const now = chileNow();
    const { target, dayLabel } = this.computeTarget(now);
    const diff = target - now;

    this.el.hidden = false;
    if (this.dayLabelEl) this.dayLabelEl.textContent = dayLabel;

    const totalSeconds = Math.max(0, Math.floor(diff / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value) => String(value).padStart(2, '0');

    this.hoursEl.textContent = pad(hours);
    this.minutesEl.textContent = pad(minutes);
    this.secondsEl.textContent = pad(seconds);
  }
}

document.querySelectorAll('[data-delivery-countdown]').forEach((el) => new DeliveryCountdown(el));
